module.exports = __webpack_public_path__ + "img/wx.97073166.png";